import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgChevronUp = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m5.24 14.442 6.207-5.946c.178-.176.373-.276.568-.276s.388.072.538.217l6.206 5.946c.312.297.322.79.024 1.1a.776.776 0 0 1-1.102.024l-5.666-5.4-5.697 5.455a.775.775 0 0 1-1.1-.023.77.77 0 0 1 .023-1.097"
    }));
export default SvgChevronUp;
